'use strict';

angular.module('DoohApps').directive('assetUploader', ['treeControlHelper', 'MediaAssetsBLL', 'DialogHandler', '$q', 'User' , 'DoohConfig', function (treeControlHelper, MediaAssetsBLL, DialogHandler, $q, User, DoohConfig) {
    return {
        restrict: 'E',
        scope: {
            onlyImages: '=',
            assetpath: '=',
            companyId: '=',
            onAssetsUploaded: '&',
            onUploadStarted: '&',
            maxFiles: '='
        },
        link: function (scope, elem) {
            scope.$on('$destroy', function () {
                scope.NewAssetsObj = {};
            });

            scope.isGuest = User.hasAccess('IsGuestUser')

            scope.maxFiles = scope.maxFiles || 10;

            scope.NewAssetsObj = {
                MediaAssetFolderID: scope.assetpath[scope.assetpath.length - 1].node
            };

            scope.attachmentSelected = function () {
                scope.NewAssetsObj.Files.map(function (file) {
                    file.MediaAssetFolderID = scope.NewAssetsObj.MediaAssetFolderID;
                    file.path = scope.assetpath;
                    if (scope.companyId != undefined)
                        file.CompanyId = scope.companyId;
                });
            }

            scope.changeDefAssetLocation = function () {
                treeControlHelper.openTreeControl(function (data) {
                    scope.NewAssetsObj.MediaAssetFolderID = data.folder.node;
                    scope.assetpath = data.path;
                }, scope.assetpath, scope.companyId);
            }

            scope.changeAssetLocation = function (file) {
                treeControlHelper.openTreeControl(function (data) {
                    file.path = data.path;
                    file.MediaAssetFolderID = data.folder.node;
                }, file.path, scope.companyId);
            }

            var onProgress = function (percentsComplete, asset, onCancel) {
                percentsComplete = parseInt(percentsComplete);
                if (percentsComplete > 1)
                    asset.uploadStarting = false;

                if (!scope.NewAssetsObj.HasFile) {
                    onCancel();
                    return;
                }
                asset.uploadProgress = percentsComplete;
                if (percentsComplete == 100) {                    
                    asset.uploadFinishing = true;
                }
            }

            var onUploaded = function (url, asset) {
                asset.FileURL = url;
                var assetDTO = {
                    AssetTitle: asset.AssetTitle,
                    Description: asset.Description,
                    AssetType: asset.AssetType,
                    CompanyId: asset.CompanyId,
                    LanguageId: asset.LanguageId,
                    IsPublic: asset.IsPublic,
                    FileUrl: asset.FileURL,
                    FileExtension: asset.FileExtension,
                    FileDuration: asset.FileDuration,
                    FileSize: asset.FileSize,
                    SnapshotFromSecond: asset.SnapshotFromSecond,
                    TagList: asset.TagList,
                    MediaAssetFolderID: asset.MediaAssetFolderID
                }

                MediaAssetsBLL.addNewMediaAsset(function (data) {
                    if (data.status == 400) {
                        asset.error = true;
                        asset.uploadFinishing = false;
                    } else {
                        var resp = data.Data.Content;
                        asset.MediaAssetID = resp.MediaAsset;
                        asset.CreatedByUser = resp.UserId;
                        asset.CreatedOn = resp.CreatedOn;
                        asset.CreatedBy = resp.CreatedBy;
                        asset.FileDuration = resp.Duration;
                        asset.Resolution = resp.Resolution;
                        asset.IconUrl = resp.IconUrl;
                        asset.file = null;
                        asset.uploadFinishing = false;
                        asset.done = true;
                    }

                    var finishedAssets = scope.NewAssetsObj.Files.filter(function (asset) { return asset.done || asset.error });
                    if (finishedAssets.length == scope.NewAssetsObj.Files.length) {
                        var successAssets = finishedAssets.filter(function (asset) { return asset.done });
                        var failedAssets = finishedAssets.filter(function (asset) { return asset.error });
                        scope.onAssetsUploaded({ assets: successAssets, failedAssets: failedAssets });
                    }
                }, assetDTO);
            }

            var onError = function (asset) {
                asset.error = true;
                asset.uploadFinishing = false;
                asset.uploadStarting = false;
            }

            scope.SaveNewMediaAsset = function () {
                if (scope.NewAssetsObj.HasFile && !scope.UploadStarted && !scope.NewAssetsObj.Files.some(function (file) { return file.AssetTitle == undefined || file.AssetTitle.trim() == '' })) {
                    scope.NewAssetsObj.Files.forEach(asset => asset.uploadStarting = true);
                    scope.UploadStarted = true;
                    if (scope.onUploadStarted !== undefined)
                        scope.onUploadStarted();

                    MediaAssetsBLL.uploadMediaAssets(
                        scope.NewAssetsObj.Files,
                        onProgress,
                        onUploaded,
                        onError,
                        scope.companyId);
                }
            }

            scope.getTags = function (filter) {
                var deferred = $q.defer();
                var test = [];
                if (filter.length < 2) {
                    deferred.resolve(test);
                    return deferred.promise;
                }
                MediaAssetsBLL.getTagList(function (data) {
                    if (data.error_description == undefined) {
                        test = data.Data.Content;
                    }
                    else
                        test = [];
                    deferred.resolve(test);

                }, filter);
                return deferred.promise;
            }
        },
        templateUrl: '/../Templates/Partials/Templates/assetUploader.html?v=' + DoohConfig.version
    }
}]);